import {useEffect, useState} from "react";

export function useQueryParams<T = object>() {
    const [queryParams, setQueryParams] = useState<T | undefined>(undefined);
    useEffect(() => {
        const queryParams = window.location.search.split('?')[1]?.split('&').reduce((p, i) => {
            const [key, value] = i.split('=');
            return {...p, [key]: value}
        }, {}) || {}
        setQueryParams(queryParams as T)
    }, [])
    return queryParams
}
